import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

import { 
    userLoginReducer,userProfileReducer } from './redux/reducers/userReducers'
    
import { 
    colorsReducer } from './redux/reducers/colorsReducers'

import { 
    industryReducer } from './redux/reducers/industryReducers'

const reducer = combineReducers({

    userLogin:userLoginReducer,
    userProfile:userProfileReducer,
    optionsColors:colorsReducer,
    optionsIndustry:industryReducer

})

const userDetailsFromLocalStorage = localStorage.getItem('userDetails') 
              ? JSON.parse(localStorage.getItem('userDetails'))
              : []

const initialState = {
    userLogin:{ userDetails:userDetailsFromLocalStorage },
    optionsColors:{},
    optionsIndustry:{}
}

const middleware = [thunk]

const store = createStore(
    reducer, initialState, composeWithDevTools(applyMiddleware(...middleware))
)

export default store